import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReactModal from '../modules/ReactModal'
import Button from '../elements/Button'
import LoadingOverlay from './LoadingOverlay'

const ReportIncorrect = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [isComplete, setIsComplete] = useState(false)
    const [showModal, setShowModal] = useState(false)

    const handleConfirm = event => {
        event.preventDefault()
        setIsLoading(true)

        setTimeout(() => {
            setIsComplete(true)
            setIsLoading(false)
        }, 2000)
    }

    const handleCancel = event => {
        event.preventDefault()
        setShowModal(false)
    }

    const Success = <p className='form-success'>Log item reported successfully.<br /><br /><a href='#' onClick={handleCancel}>Close</a></p>

    return (
        <div className='report-incorrect'>
            <div className='text-center text-lg-right font-xsmall'>
                <p className='m-0 link' onClick={() => setShowModal(true)}>Report incorrect</p>
            </div>
            <ReactModal showModal={showModal} handleCloseModal={() => setShowModal(false)} heading='Report incorrect'>
                <div className='row justify-content-center report-incorrect-modal'>
                    <div className='col-12 col-lg-8 text-center'>
                        <p className='mt-0 mb-4 lh'>If you believe <span className='bold'>{props.blockName}</span> has been incorrectly blocked or categorised under <span className='bold'>{props.blockType}</span>, click "report incorrect" below and we will have it reviewed at as soon as possible.</p>
                        {isComplete
                            ? Success
                            : <LoadingOverlay isLoading={isLoading}>
                                <div className='d-flex justify-content-center'>
                                    <Button title='Report incorrect' action={handleConfirm} className='mr-3' />
                                    <Button title='Cancel' action={handleCancel} color='red' />
                                </div>
                              </LoadingOverlay>}
                    </div>
                    {props.children}
                </div>
            </ReactModal>
        </div>
    )
}

ReportIncorrect.propTypes = {
    blockType: PropTypes.string.isRequired,
    blockName: PropTypes.string.isRequired
}

export default ReportIncorrect



// WEBPACK FOOTER //
// ./resources/js/components/ReportIncorrect.js